import { PAGE_PATHS } from '@/services/paths'
import { EVENT_KEYS, sendToDataLayer } from '@/services/events'

import CustomCompleteAnatomy from '@/components/LandingPage/PageComponents/Contents/ContentDetailsSection/DetailsItem/CustomItems/CompleteAnatomy'
import CustomPathology from '@/components/LandingPage/PageComponents/Contents/ContentDetailsSection/DetailsItem/CustomItems/Pathology'
import CustomPhysiology from '@/components/LandingPage/PageComponents/Contents/ContentDetailsSection/DetailsItem/CustomItems/Physiology'
import CustomRadiology from '@/components/LandingPage/PageComponents/Contents/ContentDetailsSection/DetailsItem/CustomItems/Radiology'
import CustomHistopathology from '@/components/LandingPage/PageComponents/Contents/ContentDetailsSection/DetailsItem/CustomItems/Histopathology'
import CustomCytology from '@/components/LandingPage/PageComponents/Contents/ContentDetailsSection/DetailsItem/CustomItems/Cytology'

const ICON_PATH = `${process.env.CDN_URL}/public/icons/modules`
const CONTENT_PATH = `${process.env.CDN_URL}/public/contents`
const CONTENT_FORMAT = 'webp'

export const CONTENTSPAGE_DATA = {
  banner: [
    {
      title: 'subtitles.contents1',
      text: 'subtitles.contents2',
      buttonText: 'buttons.askDemoNow',
      linkRoute: PAGE_PATHS.contact,
      buttonCallback: () => {
        sendToDataLayer({
          event: EVENT_KEYS.requestDemo
        })
      },
      image: `${CONTENT_PATH}/contents.${CONTENT_FORMAT}`
    }
  ],

  details: [
    {
      title: 'titles.specialties',
      text: 'subtitles.specialties',
      iconColor: 'var(--blue16)',
      menuColor: 'var(--light)',
      bgColor: 'var(--blue16)',
      icon: `${ICON_PATH}/radiology2.svg`,
      contents: [
        {
          title: 'titles.pathology',
          text: 'subtitles.pathology3',
          customComponent: CustomPathology,
          image: `${CONTENT_PATH}/pathology.${CONTENT_FORMAT}`
        },
        {
          title: 'titles.histopathology',
          text: 'subtitles.histopathology',
          customComponent: CustomHistopathology
        },
        {
          title: 'titles.radiology',
          text: 'subtitles.radiology3',
          customComponent: CustomRadiology,
          image: `${CONTENT_PATH}/radiology3.${CONTENT_FORMAT}`,
          newUntil: '08/01/2023'
        }
      ]
    },
    {
      title: 'titles.development',
      text: 'subtitles.development',
      iconColor: 'var(--green)',
      menuColor: 'var(--dark)',
      bgColor: 'var(--green)',
      icon: `${ICON_PATH}/embryology2.svg`,
      contents: [
        {
          title: 'titles.embryology',
          text: 'subtitles.embryology3',
          image: `${CONTENT_PATH}/embriology.${CONTENT_FORMAT}`
        },
        {
          title: 'titles.physiology',
          text: 'subtitles.physiology3',
          customComponent: CustomPhysiology,
          image: `${CONTENT_PATH}/systemic_anatomy.${CONTENT_FORMAT}`
        }
      ]
    },
    {
      title: 'titles.cellStructure',
      text: 'subtitles.cellStructure',
      iconColor: 'var(--purple5)',
      menuColor: 'var(--light)',
      bgColor: 'var(--purple5)',
      icon: `${ICON_PATH}/pathology2.svg`,
      contents: [
        {
          title: 'titles.histology',
          text: 'subtitles.histology3',
          image: `${CONTENT_PATH}/histology3.${CONTENT_FORMAT}`
        },
        {
          title: 'titles.cytology',
          text: 'subtitles.cytology3',
          customComponent: CustomCytology,
          image: `${CONTENT_PATH}/citology3.${CONTENT_FORMAT}`
        }
      ]
    },
    {
      title: 'titles.organs',
      text: 'subtitles.organs',
      icon: `${ICON_PATH}/physiology2.svg`,
      iconColor: 'var(--red2)',
      menuColor: 'var(--light)',
      bgColor: 'var(--red2)',
      contents: [
        {
          title: 'titles.completeAnatomy',
          customComponent: CustomCompleteAnatomy,
          image: `${CONTENT_PATH}/virtual_cadaver.${CONTENT_FORMAT}`
        },
        {
          title: 'titles.topographicAnatomy',
          text: 'subtitles.topographicAnatomy3',
          image: `${CONTENT_PATH}/topografy_anatomy2.${CONTENT_FORMAT}`
        },
        {
          title: 'titles.systemicAnatomy',
          text: 'subtitles.systemicAnatomy3',
          image: `${CONTENT_PATH}/systemic_anatomy2.${CONTENT_FORMAT}`
        }
      ]
    }
  ]
}
